var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "打款明细",
        visible: _vm.dialogVisible,
        width: "70%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "detail-info" }, [
        _c("p", [_vm._v("商家类型：" + _vm._s(_vm.detail.merchantType))]),
        _vm._v(" "),
        _c("p", [_vm._v("商家名称：" + _vm._s(_vm.detail.merchantName))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "对账周期：" +
              _vm._s(_vm.detail.periodStart) +
              " 至 " +
              _vm._s(_vm.detail.periodEnd)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-bar" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.openAddPaymentDialog },
            },
            [_vm._v("新增打款")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "table",
          attrs: {
            data: _vm.tableData,
            size: "mini",
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "operatorName",
              label: "操作人",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "paymentDate",
              label: "打款日期",
              "min-width": "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "打款金额", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v("¥" + _vm._s(scope.row.paymentAmount)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "feishuApplyNo",
              label: "飞书申请编号",
              "min-width": "140",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "打款凭证", "min-width": "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      { attrs: { type: "text", size: "small" } },
                      [_vm._v("查看凭证")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "打款备注",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "text-danger",
                        attrs: { type: "text", size: "small" },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.pagination.page,
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.pagination.total,
        },
      }),
      _vm._v(" "),
      _c("AddPaymentDialog", { ref: "addPaymentDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }